<div class="tabs-container">
  <ul class="">
    <li
      *ngFor="let tab of tabItem"
      (click)="selectTab(tab)"
      [class.active]="tab.active"
    >
      <img class="img-icon" [src]="'icons/' + tab.tabIcon" alt="" />
      <a href="javascript: void(0);">{{ tab.tabTitle }}</a>
    </li>
  </ul>
  <ng-content></ng-content>
</div>
